import React from 'react';
import { useNavigate } from 'react-router-dom';
import CategoryBreakdown from './CategoryBreakdown';
import { parseFloatFromString } from '../utils/formatters';
import { positionsListNavState } from '../utils/positionsListNavState';

const UNASSIGNED_NAMES = ['unassigned', 'unknown', 'unlocated'];

const LocationBreakdown = ({ locationCategories = [], positionsPath = '/positions' }) => {
  const navigate = useNavigate();

  // Show only when there is at least one real location; include Unassigned as a category alongside it.
  const hasRealLocations = (locationCategories || []).some((category) => (
    parseFloatFromString(category.value) > 0 && !UNASSIGNED_NAMES.includes(String(category.name).toLowerCase())
  ));
  if (!hasRealLocations) return null;

  return (
    <CategoryBreakdown
      title="Locations"
      categories={locationCategories}
      animationKey="locations-current-value"
      onSelect={(name) => navigate(positionsPath, { state: positionsListNavState({ locationName: name }) })}
    />
  );
};

export default LocationBreakdown;
